import {useLocation} from 'react-router-dom';

import PageLayout, {PageDescription} from '@/shared/components/PageLayout';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';

interface LocationState {
  state?: {
    message?: string;
  };
}

const UnderMaintenancePage = () => {
  const {state} = useLocation() as LocationState;

  return (
    <PageLayout
      tiara={{pageName: TIARA_PAGE_NAME.ERROR, pageAction: TIARA_ACTION.UNDER_MAINTENANCE_ERROR}}
      showLogo
      footerProps={{type: 'simple'}}
      pageDescription={PageDescription.GUIDE}
    >
      <div className="wrap_comm wrap_error">
        <div className="cont_comm">
          <strong className="tit_info">서비스 점검 중</strong>
          <p className="desc_info">
            안정적인 서비스 제공을 위해 점검 중 입니다.
            <br />
            최선을 다해 빠르게 마무리 하겠습니다.
          </p>
          {state?.message && (
            <div className="box_desc">
              <p className="txt_empty">{state.message}</p>
            </div>
          )}
        </div>
      </div>
    </PageLayout>
  );
};

export default UnderMaintenancePage;
